var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgGenera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.731,
    height: 13.309,
    viewBox: "0 0 10.731 13.309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-document-6260654",
    transform: "translate(-6.911 -1.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4557",
    "data-name": "Raggruppa 4557",
    transform: "translate(6.911 1.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9566",
    "data-name": "Tracciato 9566",
    d: "M36.92,2.481V5.857H40.3Z",
    transform: "translate(-29.803 -2.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9567",
    "data-name": "Tracciato 9567",
    d: "M14.028,6.2a1.109,1.109,0,0,1-1.107-1.107V1.477H7.962A1.058,1.058,0,0,0,6.911,2.527V13.735a1.058,1.058,0,0,0,1.051,1.051h8.63a1.058,1.058,0,0,0,1.051-1.051V6.2Zm.756,6.262H9.769a.553.553,0,1,1,0-1.107h5.015a.562.562,0,0,1,.56.56A.55.55,0,0,1,14.784,12.46Zm0-2.83H9.769a.562.562,0,0,1-.56-.56.55.55,0,0,1,.56-.546h5.015a.553.553,0,1,1,0,1.107Z",
    transform: "translate(-6.911 -1.477)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgGenera);
export default __webpack_public_path__ + "static/media/SvgGenera.9a369d4f8319bba9405d9040a5afa57b.svg";
export { ForwardRef as ReactComponent };